<template>
  <div class="row">
    <!--    <div-->
    <!--      v-if="!isGetResult"-->
    <!--      class="LuanGiaiTuoi">-->
    <!--      <div class="title">Dành riênh cho tuổi của bạn</div>-->
    <!--      <div class="intro">-->
    <!--        Căn cứ vào ngày tháng năm sinh của bạn, hệ thống sẽ tự động phân tích và trả kết quả hàng ngày:-->
    <!--        <div><img src="../../assets/img/basic/tick.png">Hôm nay tốt xấu với bạn thế nào ?</div>-->
    <!--        <div><img src="../../assets/img/basic/tick.png">Nên làm gì, không nên làm gì ?</div>-->
    <!--        <div><img src="../../assets/img/basic/tick.png">Giờ nào được việc, giờ nào thì không?</div>-->
    <!--      </div>-->
    <!--      <div class="input-date-group">-->
    <!--        <div class="col-12">-->
    <!--          <div class="row">-->
    <!--            <h6> Nhập ngày tháng năm sinh dương lịch</h6>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <datetime-->
    <!--          v-model="date"-->
    <!--          class="theme-green"-->
    <!--          placeholder="Ngày sinh"-->
    <!--          format="yyyy-MM-dd"-->
    <!--          input-class="input-date"/>-->
    <!--        <img-->
    <!--          src="../../assets/img/icon/ic_chevron_left.svg"-->
    <!--          alt="">-->
    <!--      </div>-->
    <!--      <label-->
    <!--        class="radio"-->
    <!--        hidden>-->
    <!--        Nam-->
    <!--        <input-->
    <!--          v-model="gender"-->
    <!--          class="form-check-input"-->
    <!--          type="radio"-->
    <!--          name="exampleRadios"-->
    <!--          value="1">-->
    <!--        <span class="checkround"/>-->
    <!--      </label>-->
    <!--      <label-->
    <!--        class="radio"-->
    <!--        hidden>-->
    <!--        Nữ-->
    <!--        <input-->
    <!--          v-model="gender"-->
    <!--          class="form-check-input"-->
    <!--          type="radio"-->
    <!--          name="exampleRadios"-->
    <!--          value="2">-->
    <!--        <span class="checkround"/>-->
    <!--      </label>-->

    <!--      <button-->
    <!--        :disabled="!date"-->
    <!--        type="button"-->
    <!--        class="btn mt-4 btn-success col-12"-->
    <!--        @click="makeRequest()">LUẬN GIẢI CHI TIẾT-->
    <!--      </button>-->
    <!--    </div>-->
    <div
      class="KetQua">
      <div class="header"><img
        src="../../assets/img/icon/Back.png"
        @click="back()">Tư vấn Phong Thủy mỗi ngày
      </div>
      <div class="content">
        <div class="title">Dành riêng cho tuổi của hôm nay</div>
        <div class="result">
          <center>
            <div
              v-if="user && user.free_account"
              class="suggest btn w-75 my-4"
              @click="redirectToUpgrade()">
              Bạn được trải nghiệm 3 lần<br>
              BẤM VÀO ĐÂY<br>
              ĐỂ ĐƯỢC TƯ VẤN MỖI NGÀY
            </div>
          </center>
          <div
            v-if="result.td && result.td.length > 0">
            <div class="title mt-1">Hôm nay</div>
            <div
              v-for="item in result.td"
              class="detail">
              - {{ item }}
            </div>
          </div>
          <div
            v-if="result.tom_tat && result.tom_tat.length > 0">
            <div class="title mt-1">Tóm lại</div>
            <div
              v-for="item in result.tom_tat"
              class="detail">
              - {{ item }}
            </div>
          </div>
          <div
            v-if="result.gio_tot && result.gio_tot.length > 0">
            <div class="title mt-1">Giờ tốt</div>
            <div
              v-for="item in result.gio_tot"
              class="detail">
              - {{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <expired-package/>
  </div>
</template>

<script>
    import {Datetime} from "vue-datetime";
    import rf from "../../communicate/RequestFactory";
    import ExpiredPackage from './ExpiredPackage';
    import {getCurrentUser, setCurrentUser} from '../../services/authService'

    export default {
        name: "LuanGiaiTuoi",
        components: {
            ExpiredPackage,
            datetime: Datetime
        },
        data: function () {
            return {
                date: new Date().toISOString(),
                gender: 1,
                result: '',
                isGetResult: false,
                user: {}
            }
        },
      beforeCreate() {

      },
      mounted() {

            this.date = this.$route.query.birthDay;
            this.user = getCurrentUser();
            if (this.user.free_account){
                this.makeRequestVip();
            }else {
                this.makeRequestTrial();
            }
        },
        methods: {
            makeRequestTrial() {
                this.$Progress.start();
                const data = {
                    birthday: this.date
                };

                this.back();
                rf.getRequest('VirtualRequest').getSuggestTrial(data).then((res) => {
                    this.$Progress.finish();
                    if (res.status === 200) {
                        this.result = res.data;
                        this.isGetResult = true;
                        if (res.data.active_date)
                        this.user.active_date = res.data.active_date;
                        this.user.free_account = res.data.free_account;

                        setCurrentUser(this.user);
                    } else {
                        this.isGetResult = false;
                        this.$router.push('upgrade-account');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.isGetResult = false;
                })
            },
            makeRequestVip() {
                this.$Progress.start();
                const data = {
                    birthday: this.date.split('T')[0]
                };
                this.back();
                rf.getRequest('VirtualRequest').getSuggestVip(data).then((res) => {
                    this.$Progress.finish();
                    if (res.status === 200) {
                        this.result = res.data;
                        this.isGetResult = true;
                    } else {
                        this.isGetResult = false;
                        this.$router.push('upgrade-account');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.isGetResult = false;
                })
            },
            back() {
                this.isGetResult = false;
                this.result = '';
                this.$router.push('');
            },
            redirectToUpgrade() {
                this.$router.push('upgrade-account');
            }
        }
    }
</script>

<style lang="scss" scoped>
  .KetQua {
    background: white;
    width: 100%;
    margin-bottom: 65px;

    .header {
      height: 55px;
      line-height: 36px;
      background-color: #49AF4C;
      width: 100%;
      padding: 10px;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      color: white;

      img {
        cursor: pointer;
      }
    }

    .title {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
    }

    .detail {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #3B485B;
      line-height: 23px;
    }
  }
  .suggest {
    /*position: fixed;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*right: 0;*/
    background-color: #49AF4C;
    color: white;
    box-shadow: 0 15px 10px -15px #ddd;
    font-weight: 600;
    text-align: center;
    font-size: 14px;
    padding: 8px;
    border-radius:5px ;
  }
</style>



// WEBPACK FOOTER //
// src/components/luan-giai-tuoi/LuanGiaiTuoi.vue